import {
  REGISTER_NEW_REQUEST,
  INPUT_WELL_TYPE_SELECION,
  INPUT_WELL_INFO,
  INPUT_REQUEST_RIG_INFO,
  INPUT_TIMEFRAME,
  INPUT_TIME_ESTIMATE,
  INPUT_COMMENT,
  CANCEL,
  NEXT,
  SUBMIT,
} from "../../../../panelConsts"

const config = {
  type: REGISTER_NEW_REQUEST,
  index: 0,
  options: {
    heading: "Add request",
    subHeading: "New Well",
    largeModal: true,
  },
  pages: [
    {
      type: INPUT_WELL_TYPE_SELECION,
      name: "Well Type Selection",
      options: {
        hideMenu: true,
        hideInMenu: true,
        buttons: {
          left: CANCEL,
          right: NEXT,
        },
      },
    },
    {
      type: INPUT_WELL_INFO,
      name: "Well Info",
      options: {
        buttons: {
          left: CANCEL,
          right: NEXT,
        },
      },
    },
    {
      type: INPUT_REQUEST_RIG_INFO,
      name: "Rig Info",
      options: {
        buttons: {
          left: CANCEL,
          right: NEXT,
        },
      },
    },
    {
      type: INPUT_TIMEFRAME,
      name: "Timeframe",
      options: {
        buttons: {
          left: CANCEL,
          right: NEXT,
        },
      },
    },
    {
      type: INPUT_TIME_ESTIMATE,
      name: "Time Estimate",
      options: {
        buttons: {
          left: CANCEL,
          right: NEXT,
        },
      },
    },
    {
      type: INPUT_COMMENT,
      name: "Comment",
      options: {
        validated: true,
        buttons: {
          left: CANCEL,
          right: SUBMIT,
        },
      },
    },
  ],
}

export default config
